import PropTypes from 'prop-types';
import React from 'react';
import ConversationFilter from './ConversationFilter';

class ConversationFilterContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterValue: '',
      focused: false,
    };
    this.onBlur = this.onBlur.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onFocus = this.onFocus.bind(this);
  }

  onBlur() {
    this.setState({ focused: false });
  }

  onChange(event) {
    const { onChange } = this.props;
    const filterValue = event.target.value;
    this.setState({ filterValue });
    onChange(filterValue);
  }

  onFocus() {
    this.setState({ focused: true });
  }

  reset() {
    const { onChange } = this.props;
    this.setState({ filterValue: '' });
    onChange('');
  }

  render() {
    const { filterValue, focused } = this.state;
    const { handleCollapse, getInputProps } = this.props;

    return (
      <ConversationFilter
        focused={focused}
        value={filterValue}
        onBlur={this.onBlur}
        onChange={this.onChange}
        onFocus={this.onFocus}
        getInputProps={getInputProps}
        handleCollapse={handleCollapse}
      />
    );
  }
}

ConversationFilterContainer.propTypes = {
  onChange: PropTypes.func.isRequired,
  getInputProps: PropTypes.func.isRequired,
  handleCollapse: PropTypes.func.isRequired,
};

export default ConversationFilterContainer;
